/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectSubtaskResponseDto } from '../../models/core-project-subtask-response-dto';

export interface ProjectSubtasksControllerFindOne$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the project subtask to retrieve.
 */
  id: string;
}

export function projectSubtasksControllerFindOne(http: HttpClient, rootUrl: string, params: ProjectSubtasksControllerFindOne$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtasksControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>;
    })
  );
}

projectSubtasksControllerFindOne.PATH = '/o2-core/project-subtasks/{tenant}/{id}';
